/**
 * Référence statique des POS de l'opération QR Code.
 * Source : Databook_Offre_WEST_17052026_1.xlsx (feuille "3. Données POS").
 *
 * Version : 3 (nouvelle base Databook complète avec framework KPI).
 * Nombre de POS : 203
 * Potentiel total : 28,207 paquets sur 2 semaines
 *                  (soit 2,820.7 cartouches × 10 paquets/cartouche)
 *
 * BARÈME OFFICIEL DES OFFRES (slide WEST — Incentive POS et consommateur) :
 *   OFFRE 1 : POS 20 DA + Consommateur 20 DA par paquet scanné
 *   OFFRE 2 : POS 20 DA + Consommateur  0 DA (seul le POS reçoit)
 *   OFFRE 3 : POS 20 DA + Consommateur 1000 DA tous les 3 paquets scannés
 *
 * Note : le Databook contient des valeurs de simulation financière, mais
 * le barème opérationnel reste celui défini par le client (ci-dessus).
 *
 * 1 cartouche = 10 paquets (facteur de conversion pour le potentiel).
 */

export const PAQUETS_PAR_CARTOUCHE = 10

export const POS_REFERENCE = [
  {
    "code": "46190005",
    "nom_compte": "MOUSSAOUI ABDELKADER",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL AMRIA",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "46190014",
    "nom_compte": "CHAKIRI BAROUDI",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL AMRIA",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 13,
    "segment": "P1",
    "objectif_cartouches_2w": 19.5,
    "potentiel": 195,
    "offre": "OFFRE 3"
  },
  {
    "code": "46190037",
    "nom_compte": "BEN HAMOU OUSSAMA",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL AMRIA",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 3"
  },
  {
    "code": "46200020",
    "nom_compte": "SAID ADEM",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "HASSI EL GHELLA",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 7,
    "segment": "P1",
    "objectif_cartouches_2w": 10.5,
    "potentiel": 105,
    "offre": "OFFRE 1"
  },
  {
    "code": "46140014",
    "nom_compte": "MOKDAD FOUAD",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL MALAH",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P1",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "46010043",
    "nom_compte": "KHALADI NOURREDINE",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "AIN-TEMOUCHENT",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P1",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 2"
  },
  {
    "code": "46010015",
    "nom_compte": "MERBOUH KAMEL",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "AIN-TEMOUCHENT",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P1",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "46190020",
    "nom_compte": "BENHAMOU KHALED",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL AMRIA",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P1",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "46140018",
    "nom_compte": "BOUCHENTOUF YOUCEF",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL MALAH",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P1",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 3"
  },
  {
    "code": "46140001",
    "nom_compte": "BENZARGA LAKHDAR",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL MALAH",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "46010024-U",
    "nom_compte": "BENSALEM ABDELAZIZ",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "AIN-TEMOUCHENT",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P1",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 3"
  },
  {
    "code": "46140029",
    "nom_compte": "SAID MED AMINE 2",
    "region": "OUEST",
    "wilaya": "AIN-TEMOUCHENT",
    "commune": "EL MALAH",
    "commercial": "AMINE RACHED KHALLOUFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P1",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 1"
  },
  {
    "code": "16550051",
    "nom_compte": "NASSIM EL NADJEH",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BABA HASSEN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 250,
    "segment": "P1",
    "objectif_cartouches_2w": 375.0,
    "potentiel": 3750,
    "offre": "OFFRE 1"
  },
  {
    "code": "16320029",
    "nom_compte": "BERKANOU TOUFIK",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BENI MESSOUS",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P1",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "16250026",
    "nom_compte": "KHALFI ALI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "RAIS HAMIDOU",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P1",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "16100003",
    "nom_compte": "AFAFSA FOUZI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 2"
  },
  {
    "code": "16110001",
    "nom_compte": "AIWAZ MORAD",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BOUZAREAH",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 2"
  },
  {
    "code": "16530008",
    "nom_compte": "BOUFELFEL YOUCEF",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "DRARIA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "16470007-U",
    "nom_compte": "AHCEN MOHAMED AMINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "MAHELMA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16100055",
    "nom_compte": "AIT MESSAOUD MOHAMED AMINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16510047",
    "nom_compte": "ABDOU ZENTANI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "OULED FAYET",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16100019",
    "nom_compte": "L'EQUIPE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16220012",
    "nom_compte": "MEKADEM YACINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BEN AKNOUN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "16390035",
    "nom_compte": "MANAMANI MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BORDJ EL BAHRI",
    "commercial": "YOUCEF ISLAM SAHNINE",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16140044",
    "nom_compte": "TOUARI AZIZ",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BARAKI",
    "commercial": "YOUCEF ISLAM SAHNINE",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 2"
  },
  {
    "code": "16020085",
    "nom_compte": "SAYOUD FARID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "16170113",
    "nom_compte": "BOUHAIL MAKHLOUF",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "HUSSEIN DEY",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "16500012",
    "nom_compte": "ARRAS MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "CHERAGA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "16540001",
    "nom_compte": "ABADA NABIL",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "DOUERA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16320008",
    "nom_compte": "BOTAA ALI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BENI MESSOUS",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "16020063",
    "nom_compte": "BELILE CHAOUIKI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "16020060",
    "nom_compte": "SOUFI TAHAR",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "16460006",
    "nom_compte": "BOUDIAB MOUNIR",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ZERALDA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 2"
  },
  {
    "code": "16550031",
    "nom_compte": "AISSAOUI ABDELGHANI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BABA HASSEN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16020010",
    "nom_compte": "BERAR MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P1",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "16230030",
    "nom_compte": "AIT HAMADA HACEN",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "DELY BRAHIM",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16100046",
    "nom_compte": "BELAID  RAFIK",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16550009",
    "nom_compte": "BENHAMMADA MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BABA HASSEN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16500113",
    "nom_compte": "MENANE MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "CHERAGA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16220038",
    "nom_compte": "OUKACI ABEDRZAK",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BEN AKNOUN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16050077",
    "nom_compte": "GHETAB BRAHIM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BAB EL OUED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16450039",
    "nom_compte": "TABET MOLAY",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "STAOUELI",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16450072",
    "nom_compte": "AYMEN BOUZID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "STAOUELI",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "16490039",
    "nom_compte": "MOURAD CRIDI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SOUIDANIA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16100030",
    "nom_compte": "ZIT FARID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P1",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "16450053",
    "nom_compte": "HOUARI OUSSAMA",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "STAOUELI",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16100034",
    "nom_compte": "ZIAD MAHREZ",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "EL BIAR",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16210038",
    "nom_compte": "LADJANE FETHI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BEB EZZOUAR",
    "commercial": "YOUCEF ISLAM SAHNINE",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16020039",
    "nom_compte": "HARZELLAH ABDELOUAHAB",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16020024",
    "nom_compte": "DERBAL MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16500105",
    "nom_compte": "AMOUKRANE IMAD",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "CHERAGA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16010035",
    "nom_compte": "BOURETTA ABDELKRIM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ALGER",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16010074",
    "nom_compte": "REZIG TAREK",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ALGER",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16010046",
    "nom_compte": "GHANEM OUARI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ALGER",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16020023",
    "nom_compte": "DAIF ALWAHM SAID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16010115",
    "nom_compte": "LADJANI SALIM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ALGER",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16020020",
    "nom_compte": "BOUTALBI ZOHRA",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16220004",
    "nom_compte": "BOUFELLAH MOHAMED NABIL",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BEN AKNOUN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16110046",
    "nom_compte": "RIAH SOUAD",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BOUZAREAH",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16320004",
    "nom_compte": "AMENNA REDOUANE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BENI MESSOUS",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16020045",
    "nom_compte": "LOUNIS SOFIANE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16170009",
    "nom_compte": "BOHAFS FERHAT",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "HUSSEIN DEY",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16460040",
    "nom_compte": "BACHAR SOFIAN",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ZERALDA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16020041",
    "nom_compte": "BOUROUBI KAMEL",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MHAMED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16170107",
    "nom_compte": "BOUMDJIREK AHMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "HUSSEIN DEY",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16050006",
    "nom_compte": "BELASLA DJAMILA",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BAB EL OUED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16120003",
    "nom_compte": "BOUMAR ABDELHAMID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BIR KHADEM",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16120009-U",
    "nom_compte": "YAHI LAMINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BIR KHADEM",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16450068",
    "nom_compte": "BEN MEDOUR WALID",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "STAOUELI",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16120015",
    "nom_compte": "KOUACHE YOUNES",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BIR KHADEM",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16170109",
    "nom_compte": "LOUNIS BOUAELEM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "HUSSEIN DEY",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16500086",
    "nom_compte": "CHELLAHI AMINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "CHERAGA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "16050040",
    "nom_compte": "KADRI DJAMEL",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BAB EL OUED",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16120055",
    "nom_compte": "GHEFFAR MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BIR KHADEM",
    "commercial": "AHMED DOUIFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16390080",
    "nom_compte": "HAMMADI HALIM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BORDJ EL BAHRI",
    "commercial": "YOUCEF ISLAM SAHNINE",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16070003-U",
    "nom_compte": "BOUTAA HAMOUCI",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "CASBAH",
    "commercial": "MAHDI CHENAFI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P2",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "16370002",
    "nom_compte": "BERAIS ABDELAZIZ",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "SIDI MOUSSA",
    "commercial": "YOUCEF ISLAM SAHNINE",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P2",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "16460007",
    "nom_compte": "BOUROUISS SAMIR",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "ZERALDA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "16530050",
    "nom_compte": "MOUAICI HAMZA",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "DRARIA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "16550024",
    "nom_compte": "ZEBBICHE AZZEDINE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BABA HASSEN",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16110008-U",
    "nom_compte": "ADDAR MOHAMED",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BOUZAREAH",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16110015",
    "nom_compte": "LARBESSE ABDERRAHMENE",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "BOUZAREAH",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "16350008",
    "nom_compte": "WALI BOUALEM",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "TASSALA EL MERDJA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16350018",
    "nom_compte": "KOCHRANE IMAD",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "TASSALA EL MERDJA",
    "commercial": "ALI RAIAH",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 2"
  },
  {
    "code": "16430071",
    "nom_compte": "HARITI ABDELMALEK",
    "region": "CENTRE",
    "wilaya": "ALGER",
    "commune": "REGHAIA",
    "commercial": "HAFID BOURBIA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 0,
    "segment": "P3",
    "objectif_cartouches_2w": 0.0,
    "potentiel": 0,
    "offre": "OFFRE 2"
  },
  {
    "code": "23060003",
    "nom_compte": "RACHEDI BOUJEMAA",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "OUED EL ANEB",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 2"
  },
  {
    "code": "23020002",
    "nom_compte": "DENDEN RACHID",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "BERRAHEL",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 3"
  },
  {
    "code": "23110021-U",
    "nom_compte": "DJEDID EL HAMID",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "SIDI AMER",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P2",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "23010151",
    "nom_compte": "LAKHAL KAMEL",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "ANNABA",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P2",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "23050027",
    "nom_compte": "MERAMRIA ABDELMAJID",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "EL BOUNI",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 3"
  },
  {
    "code": "23010056",
    "nom_compte": "BOUCHLOUKH DJALEL",
    "region": "EST",
    "wilaya": "ANNABA",
    "commune": "ANNABA",
    "commercial": "NABIL KHENOUF",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "25010491",
    "nom_compte": "ALILI RDJEM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 150,
    "segment": "P1",
    "objectif_cartouches_2w": 225.0,
    "potentiel": 2250,
    "offre": "OFFRE 1"
  },
  {
    "code": "25050010",
    "nom_compte": "CHIKHE BOUKAL",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "DIDOUCHE MOURAD",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 1"
  },
  {
    "code": "25010204",
    "nom_compte": "KARA LYES",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 2"
  },
  {
    "code": "25010051-U",
    "nom_compte": "TABANI FATEH",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 1"
  },
  {
    "code": "25010508",
    "nom_compte": "ALLAG ZAKARIA",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P2",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060055",
    "nom_compte": "BOUGOUZINE MADJID",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P2",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060008",
    "nom_compte": "AMMARI ABDELBAKI",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P2",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060015",
    "nom_compte": "BAHLOULI HALIM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 7,
    "segment": "P2",
    "objectif_cartouches_2w": 10.5,
    "potentiel": 105,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060222",
    "nom_compte": "AYMENE DEFLA",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 7,
    "segment": "P2",
    "objectif_cartouches_2w": 10.5,
    "potentiel": 105,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060471",
    "nom_compte": "MANSOURI MOUHAMED",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25060123",
    "nom_compte": "HAROUACHE SEIF",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P3",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060040",
    "nom_compte": "BEROUAL BILLEL",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25020001",
    "nom_compte": "ABDENOUR ANOUAR",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "HAMMA BOUZIANE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25010137",
    "nom_compte": "CHAFAI LAZHAR",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060335",
    "nom_compte": "GHANI LAACHI",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060528",
    "nom_compte": "TAREK MESLEM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060014",
    "nom_compte": "BAHLOUL ISSAM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060713",
    "nom_compte": "BOUALI FOUAD",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25100057",
    "nom_compte": "BOUKARZAZA ALA EDDINE",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "AIN SMARA",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060716",
    "nom_compte": "DOUIEB ZAKARIA",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060718",
    "nom_compte": "HAMZAOUI BRAHIM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25060051",
    "nom_compte": "BOUDJENDLIA SEIF",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P3",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060529",
    "nom_compte": "SOUIAAD ADEL",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060535",
    "nom_compte": "BRACHIA LEZHAR",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060577",
    "nom_compte": "FOUGHALI MOUMEN",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060543",
    "nom_compte": "MATIB AMIR",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P3",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060412",
    "nom_compte": "AMEUR DOUADI AIMEN",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P3",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "25010040-U",
    "nom_compte": "TOURCHE SIFE",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25120008",
    "nom_compte": "BOUKENOUCHA SALEH",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "IBN ZIAD",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25060302",
    "nom_compte": "BOUHDJAR HACEN",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P3",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060667",
    "nom_compte": "GHEDABNA KHALED",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P3",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 1"
  },
  {
    "code": "25010433",
    "nom_compte": "OUSSAMA OUCHEN",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "CONSTANTINE",
    "commercial": "MAHDI ACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060658",
    "nom_compte": "MORDJANA RAHIM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060034-U",
    "nom_compte": "LAMINE ABED",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "OULED RAHMOUN",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060227",
    "nom_compte": "AFIF CHAABANE",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 3"
  },
  {
    "code": "25060585",
    "nom_compte": "KHONGUI NOUFEL",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 1"
  },
  {
    "code": "25060714",
    "nom_compte": "MIHRAB ABDERRAHMANE",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 5,
    "segment": "P3",
    "objectif_cartouches_2w": 7.5,
    "potentiel": 75,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060027",
    "nom_compte": "BENINI BELKACEM",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P3",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 2"
  },
  {
    "code": "25060185",
    "nom_compte": "RAHEM ZAKARIA",
    "region": "EST",
    "wilaya": "CONSTANTINE",
    "commune": "EL KHROUB",
    "commercial": "WALID ARAMA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P3",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 1"
  },
  {
    "code": "31030234",
    "nom_compte": "BEN MILOUD MILOUD",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 120,
    "segment": "P1",
    "objectif_cartouches_2w": 180.0,
    "potentiel": 1800,
    "offre": "OFFRE 1"
  },
  {
    "code": "31130044",
    "nom_compte": "YACINE SISINYOU",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "SIDI CHAMI",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 50,
    "segment": "P1",
    "objectif_cartouches_2w": 75.0,
    "potentiel": 750,
    "offre": "OFFRE 1"
  },
  {
    "code": "31030080",
    "nom_compte": "BELKLTOUM BOUMEDIENE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 50,
    "segment": "P1",
    "objectif_cartouches_2w": 75.0,
    "potentiel": 750,
    "offre": "OFFRE 2"
  },
  {
    "code": "31040013",
    "nom_compte": "REZMA LARBI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "HASSI BOUNIF",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 30,
    "segment": "P1",
    "objectif_cartouches_2w": 45.0,
    "potentiel": 450,
    "offre": "OFFRE 1"
  },
  {
    "code": "31010612",
    "nom_compte": "AGHA HAMID",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ORAN",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 30,
    "segment": "P1",
    "objectif_cartouches_2w": 45.0,
    "potentiel": 450,
    "offre": "OFFRE 2"
  },
  {
    "code": "31110011",
    "nom_compte": "CHEKLAL MOHAMED/BETHA",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "OUED TLELAT",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 30,
    "segment": "P1",
    "objectif_cartouches_2w": 45.0,
    "potentiel": 450,
    "offre": "OFFRE 1"
  },
  {
    "code": "31050030-U",
    "nom_compte": "MOHAMED BELKBIR",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ES SENIA",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 30,
    "segment": "P1",
    "objectif_cartouches_2w": 45.0,
    "potentiel": 450,
    "offre": "OFFRE 1"
  },
  {
    "code": "31060037",
    "nom_compte": "BELHACHEMI HOUCINE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 3"
  },
  {
    "code": "31190001",
    "nom_compte": "AID HOUARI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "HASSI BEN OKBA",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 25,
    "segment": "P1",
    "objectif_cartouches_2w": 37.5,
    "potentiel": 375,
    "offre": "OFFRE 2"
  },
  {
    "code": "31060005",
    "nom_compte": "MARCHOUCH BRAHIM",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 1"
  },
  {
    "code": "31110005",
    "nom_compte": "NIKKA KADDA",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "OUED TLELAT",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 1"
  },
  {
    "code": "31210007",
    "nom_compte": "BENALI FETHALLAH",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "HASSI MEFSOUKH",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 3"
  },
  {
    "code": "31110038",
    "nom_compte": "FOUAAD",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "OUED TLELAT",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 1"
  },
  {
    "code": "31150007",
    "nom_compte": "SEFFOUNI YACINE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "MERS EL KEBIR",
    "commercial": "MOHAMED KARADJA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 9,
    "segment": "P1",
    "objectif_cartouches_2w": 13.5,
    "potentiel": 135,
    "offre": "OFFRE 3"
  },
  {
    "code": "31140021",
    "nom_compte": "KHERCHEFA KARIM",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BOUFATIS",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "31140012",
    "nom_compte": "BERRACHED ILYES",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BOUFATIS",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 8,
    "segment": "P1",
    "objectif_cartouches_2w": 12.0,
    "potentiel": 120,
    "offre": "OFFRE 3"
  },
  {
    "code": "31110003",
    "nom_compte": "NEDRI HOUARI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "OUED TLELAT",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 17,
    "segment": "P1",
    "objectif_cartouches_2w": 25.5,
    "potentiel": 255,
    "offre": "OFFRE 2"
  },
  {
    "code": "31130055",
    "nom_compte": "BELHADJ SIDAHMED",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "SIDI CHAMI",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 3"
  },
  {
    "code": "31060063",
    "nom_compte": "KHACHA MILOUD",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 1"
  },
  {
    "code": "31110006",
    "nom_compte": "NEKAH MOHAMED",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "OUED TLELAT",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 3"
  },
  {
    "code": "31210005",
    "nom_compte": "KAMRAOUI AEK",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "HASSI MEFSOUKH",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 12,
    "segment": "P1",
    "objectif_cartouches_2w": 18.0,
    "potentiel": 180,
    "offre": "OFFRE 1"
  },
  {
    "code": "31240001",
    "nom_compte": "BENKHANCHOUCHE BOUAZZA",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BOUTLELIS",
    "commercial": "MOHAMED KARADJA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 2"
  },
  {
    "code": "31170048",
    "nom_compte": "NAHAL ABDELGHANI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "EL KARMA",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 18,
    "segment": "P1",
    "objectif_cartouches_2w": 27.0,
    "potentiel": 270,
    "offre": "OFFRE 2"
  },
  {
    "code": "31010989",
    "nom_compte": "AFLOU OMAR",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ORAN",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "31130031",
    "nom_compte": "AMRI ABDELMADJID",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "SIDI CHAMI",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 16,
    "segment": "P1",
    "objectif_cartouches_2w": 24.0,
    "potentiel": 240,
    "offre": "OFFRE 3"
  },
  {
    "code": "31030351",
    "nom_compte": "BELARBI SIDAHMED",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "31030283",
    "nom_compte": "BENAMARA MILOUD",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 1"
  },
  {
    "code": "31160005",
    "nom_compte": "HABOUCHII FETHI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BOUSFER",
    "commercial": "MOHAMED KARADJA",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 6,
    "segment": "P1",
    "objectif_cartouches_2w": 9.0,
    "potentiel": 90,
    "offre": "OFFRE 2"
  },
  {
    "code": "31060018",
    "nom_compte": "TAHIET HABIB",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 8,
    "segment": "P1",
    "objectif_cartouches_2w": 12.0,
    "potentiel": 120,
    "offre": "OFFRE 3"
  },
  {
    "code": "31060020",
    "nom_compte": "BENSLIM OTMANE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 8,
    "segment": "P1",
    "objectif_cartouches_2w": 12.0,
    "potentiel": 120,
    "offre": "OFFRE 3"
  },
  {
    "code": "31050019-U",
    "nom_compte": "AYOUB TERKI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ES SENIA",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 14,
    "segment": "P1",
    "objectif_cartouches_2w": 21.0,
    "potentiel": 210,
    "offre": "OFFRE 2"
  },
  {
    "code": "31050205",
    "nom_compte": "BOUKAMBOUCHE BADREDINE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ES SENIA",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "31210034",
    "nom_compte": "MOHAMED ZAHAF",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "HASSI MEFSOUKH",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 1"
  },
  {
    "code": "31010990",
    "nom_compte": "MOUSSAOUI ISMAIL",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ORAN",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 1"
  },
  {
    "code": "31080005",
    "nom_compte": "BENNOURAD GNAOUI",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "MARSAT EL HADJADJ",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 1"
  },
  {
    "code": "31060003",
    "nom_compte": "LARBI FOUAD",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 2"
  },
  {
    "code": "31060013",
    "nom_compte": "MESSAR ABDELAZIZ",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ARZEW",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 2"
  },
  {
    "code": "31140005",
    "nom_compte": "DIDAH FATIS",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BOUFATIS",
    "commercial": "YOUCEF DJELLOULI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 10,
    "segment": "P1",
    "objectif_cartouches_2w": 15.0,
    "potentiel": 150,
    "offre": "OFFRE 1"
  },
  {
    "code": "31050209",
    "nom_compte": "ZEROUKI NOURDINE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ES SENIA",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 13,
    "segment": "P1",
    "objectif_cartouches_2w": 19.5,
    "potentiel": 195,
    "offre": "OFFRE 3"
  },
  {
    "code": "31050172",
    "nom_compte": "BENDOUMA HAMID",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "ES SENIA",
    "commercial": "MOHAMED HAMDANI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 3"
  },
  {
    "code": "31030007",
    "nom_compte": "NACER ABDELAZIZ",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 1"
  },
  {
    "code": "31030302",
    "nom_compte": "ANIS BEDOUHENE",
    "region": "OUEST",
    "wilaya": "ORAN",
    "commune": "BIR EL DJIR",
    "commercial": "WASSIM ELMOKRETAR",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 15,
    "segment": "P1",
    "objectif_cartouches_2w": 22.5,
    "potentiel": 225,
    "offre": "OFFRE 2"
  },
  {
    "code": "22030009",
    "nom_compte": "NADJI AIMEN",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BRAHIM",
    "commercial": "KHALID SENOUSSAOUI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 1"
  },
  {
    "code": "22290029",
    "nom_compte": "NOUARI FETHI",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SFISEF",
    "commercial": "KHALID SENOUSSAOUI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 20,
    "segment": "P1",
    "objectif_cartouches_2w": 30.0,
    "potentiel": 300,
    "offre": "OFFRE 3"
  },
  {
    "code": "22280020",
    "nom_compte": "BOUKHALDA NOUREDDINE",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "AIN EL BERD",
    "commercial": "KHALID SENOUSSAOUI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 14,
    "segment": "P1",
    "objectif_cartouches_2w": 21.0,
    "potentiel": 210,
    "offre": "OFFRE 2"
  },
  {
    "code": "22290033",
    "nom_compte": "BENHOUIDGA KHIREDINE",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SFISEF",
    "commercial": "KHALID SENOUSSAOUI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P2",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 2"
  },
  {
    "code": "22010415",
    "nom_compte": "LOUAFI ABDELHADI",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 4,
    "segment": "P2",
    "objectif_cartouches_2w": 6.0,
    "potentiel": 60,
    "offre": "OFFRE 2"
  },
  {
    "code": "22010120",
    "nom_compte": "LAKHAL SOFIAN",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 3,
    "segment": "P2",
    "objectif_cartouches_2w": 4.5,
    "potentiel": 45,
    "offre": "OFFRE 3"
  },
  {
    "code": "22010132",
    "nom_compte": "MOULEFARAA ADEL",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "22010305",
    "nom_compte": "KAROUMI SALEH",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "22010038",
    "nom_compte": "RAHIL ELHADJ",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "22010350",
    "nom_compte": "MAAROUF MOHAMED AMINE",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "22010487",
    "nom_compte": "BENOUISE ADEL",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 3"
  },
  {
    "code": "22010105-U",
    "nom_compte": "ZAHAF OUALID",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "22010374",
    "nom_compte": "MOUKAIDECH ABDELMALEK",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "22010494",
    "nom_compte": "BEN AYED FOUFIK",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 2"
  },
  {
    "code": "22010447",
    "nom_compte": "NOUALA ABDELKARIM",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P3",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "22010472",
    "nom_compte": "KELLAL KHEIREDDINE",
    "region": "OUEST",
    "wilaya": "SIDI BEL ABBES",
    "commune": "SIDI BEL ABBES",
    "commercial": "MOHAMED BACHI",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 1.5,
    "potentiel": 15,
    "offre": "OFFRE 1"
  },
  {
    "code": "44010053",
    "nom_compte": "KADIRI AZIOUZ",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "AIN-DEFLA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 3"
  },
  {
    "code": "44040005",
    "nom_compte": "SISI MOHAMED",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "KHEMIS MILIANA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 2,
    "segment": "P1",
    "objectif_cartouches_2w": 3.0,
    "potentiel": 30,
    "offre": "OFFRE 1"
  },
  {
    "code": "44010061",
    "nom_compte": "MOKADEM ABDELKADER",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "AIN-DEFLA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44100012",
    "nom_compte": "CHEKRARE TAYEB",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "EL ATTAF",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P2",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44090006",
    "nom_compte": "ZENNATI MOUSSA",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "BOURACHED",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44100009",
    "nom_compte": "HOUARI ABDELLAH",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "EL ATTAF",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44120003",
    "nom_compte": "HALIM FAGHALI",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "DJENDEL",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44100017",
    "nom_compte": "BEN AHMED DJILALI",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "EL ATTAF",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44100005",
    "nom_compte": "BETTAHER OUSSAMA",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "EL ATTAF",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.3,
    "potentiel": 23,
    "offre": "OFFRE 1"
  },
  {
    "code": "44090012",
    "nom_compte": "MAGHRAOUI MISSOUM",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "BOURACHED",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.5,
    "potentiel": 25,
    "offre": "OFFRE 2"
  },
  {
    "code": "44070002",
    "nom_compte": "KOUADRI ABDNOUR",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "DJELIDA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.5,
    "potentiel": 25,
    "offre": "OFFRE 2"
  },
  {
    "code": "44040008",
    "nom_compte": "HAMOUDA SOFIANE",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "KHEMIS MILIANA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.5,
    "potentiel": 25,
    "offre": "OFFRE 2"
  },
  {
    "code": "44010030",
    "nom_compte": "BOUKADOUM NOUREDDINE",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "AIN-DEFLA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.6,
    "potentiel": 26,
    "offre": "OFFRE 3"
  },
  {
    "code": "44010008",
    "nom_compte": "RACHDI KARIM",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "AIN-DEFLA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.6,
    "potentiel": 26,
    "offre": "OFFRE 3"
  },
  {
    "code": "44010005",
    "nom_compte": "YACINE COSMÉTIQUE",
    "region": "CENTRE",
    "wilaya": "AIN-DEFLA",
    "commune": "AIN-DEFLA",
    "commercial": "ABDEREZAK LAKAS",
    "shop_type": "Détaillant",
    "volume_habituel_cartouches": 1,
    "segment": "P3",
    "objectif_cartouches_2w": 2.6,
    "potentiel": 26,
    "offre": "OFFRE 3"
  }
]

// Lookup table pour recherche O(1) par code
export const POS_BY_CODE = POS_REFERENCE.reduce((acc, p) => {
  acc[p.code] = p
  return acc
}, {})

// Dimensions distinctes triées, prêtes pour les filtres
export const REGIONS = [...new Set(POS_REFERENCE.map(p => p.region))].sort()
export const WILAYAS = [...new Set(POS_REFERENCE.map(p => p.wilaya))].sort()
export const SEGMENTS = [...new Set(POS_REFERENCE.map(p => p.segment))].sort()
export const OFFRES = ['OFFRE 1', 'OFFRE 2', 'OFFRE 3']
export const COMMUNES = [...new Set(POS_REFERENCE.map(p => p.commune).filter(Boolean))].sort()

// Potentiel total (paquets sur 2 semaines)
export const POTENTIEL_TOTAL = POS_REFERENCE.reduce((s, p) => s + p.potentiel, 0)

// Barème officiel des offres (slide WEST — Incentive POS et consommateur)
// posPerPaquet       : DA versés au POS par paquet scanné
// consoPerPaquet     : DA versés au consommateur par paquet scanné (null si cumul)
// consoCumul         : si présent, le consommateur reçoit `amount` DA tous les `every` paquets
// avgCostPerPaquet   : coût moyen total par paquet (POS + consommateur), utile pour les estimations
export const OFFRE_BAREMES = {
  'OFFRE 1': { posPerPaquet: 20, consoPerPaquet: 20, consoCumul: null, avgCostPerPaquet: 40 },
  'OFFRE 2': { posPerPaquet: 20, consoPerPaquet: 0, consoCumul: null, avgCostPerPaquet: 20 },
  'OFFRE 3': { posPerPaquet: 20, consoPerPaquet: 0, consoCumul: { amount: 1000, every: 3 }, avgCostPerPaquet: 20 + 1000 / 3 },
}

// Regroupement wilaya → région
export const WILAYA_TO_REGION = POS_REFERENCE.reduce((acc, p) => {
  acc[p.wilaya] = p.region
  return acc
}, {})

export default POS_REFERENCE